import { useEffect, useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Autocomplete, TextField, TextFieldVariants } from '@mui/material';
import { Role } from '@src/constants/Roles';
import UserList from '@src/cache/UserList';
import UserInfoDTO from '@src/adapters/dto/user/UserInfoDTO';

interface Props {
  name: string;
  control: Control<any>;
  variant?: TextFieldVariants;
  label?: string;
  roles?: Role[];
}

function UserControlledAutoComplete({
  name,
  control,
  variant,
  label,
  roles,
}: Props) {
  const [items, setItems] = useState<UserInfoDTO[]>([]);
  const { getList: getUsers } = UserList();

  useEffect(() => {
    getUsers().then((result) => {
      setItems(
        !roles || roles.length === 0
          ? result
          : result.filter((i) =>
              i.roles.some((role) => roles.includes(role as Role))
            )
      );
    });
  }, [getUsers, roles]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          options={items}
          freeSolo={false}
          getOptionLabel={(option) =>
            [option.firstName, option.lastName].filter(Boolean).join(' ')
          }
          value={items.find((opt) => opt.id === value) || null}
          onChange={(_, newValue) => {
            onChange(newValue ? newValue.id : null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label ? label : 'User'}
              variant={variant}
            />
          )}
        />
      )}
    />
  );
}

export default UserControlledAutoComplete;
